class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    // We no longer need IntersectionObserver or API fetching.
    // Just run the shuffle logic immediately or on load.
    
    // Ensure styles are ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.#initRandomization());
    } else {
      this.#initRandomization();
    }
  }

  #initRandomization() {
    const container = this.querySelector('[data-recommendations-container]');
    if (!container) return;

    // Collect all invisible wrappers
    const items = Array.from(container.querySelectorAll('.recommendation-item-wrapper'));
    
    // Fisher-Yates Shuffle
    for (let i = items.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }

    // Decide how many to show (hardcoded 2 based on request)
    const maxDisplay = 2;
    
    // Clear container to re-append in order
    // But we need to maintain the structure. 
    // The previous implementation replaced innerHTML. Let's do that cleanly.
    
    // Clear current children
    container.innerHTML = '';

    // Append the first 2 items and make them visible
    const selectedItems = items.slice(0, maxDisplay);
    
    selectedItems.forEach(wrapper => {
      // Remove the display:none style
      wrapper.style.display = 'block';
      
      // Handle the card visibility
      // The content inside is the card which has opacity-0
      const card = wrapper.querySelector('.experience-card');
      if (card) {
        card.classList.remove('opacity-0');
        card.style.opacity = '1';
        // Also ensure it is not translated if animation left it somewhere
        card.style.transform = 'none';
      }

      container.appendChild(wrapper);
    });

    // Make the section visible if it was hidden
    // The previous CSS had: product-recommendations:has([data-has-recommendations='false']) { display: none; }
    // We should probably ensure we remove any such attributes or classes from the host.
    this.removeAttribute('data-has-recommendations'); // or set to true if needed logic relies on it
    
    // Initialize cards (listeners, currency, etc)
    if (typeof window.__initExperienceCards === 'function') {
      window.__initExperienceCards();
    }
  }
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations);
}

// Keep the fallback init just in case other scripts rely on it
const initExperienceCardsFallback = () => {
    // ... existing fallback code logic if needed ...
    // Since the fallback was quite long in the previous file, 
    // and it seems it's used globally, i should probably preserve it exactly as it was.
    // I'll grab the previous content for this part.
};
// ... (omitting strict copy implementation for brevity in this prompt, but in real file I will include it)

// Actually, let me write the FULL file content to be safe and complete.
